export const ASC = "ASC";
export const DESC = "DESC";

export const DIRECTIONS = {
  ascend: ASC,
  descend: DESC,
  ASC,
  DESC,
} as const;
